<template>
  <div
    class="modal"
    id="sessionDetailModalVue"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-detail"
      role="document"
    >
      <div class="modal-content text-black">
        <div class="modal-header">
          <h5 class="modal-title">Session Details</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body session-dialog-data">
          <!-- name -->
          <div>
            <h5 v-if="session.code && conferenceId != 8457">{{ session.code }} - {{ session.name }}</h5>
            <h5 v-else>{{ session.name }}</h5>
          </div>

          <!-- type -->
          <div v-if="isHybridConference">
            <div v-if="session.is_hybrid_session">
              <i class="fa-regular fa-laptop-house"></i>&nbsp;&nbsp; Hybrid
              Session
            </div>

            <div v-else>
              <div v-if="session.is_inperson_session">
                <i class="fa-regular fa-people-group"></i>&nbsp;&nbsp;
                <span>In-Person Only</span>
              </div>

              <span v-if="session.is_virtual_session">
                <i class="fa-regular fa-laptop"></i>&nbsp;&nbsp;
                <span>Virtual Only</span>
              </span>
            </div>
          </div>

          <!-- room name -->
          <div class="block-info" v-if="session.room_name">
            <h6>Room:</h6>
            <p>{{ session.room_name }}</p>
          </div>

          <!-- tracks -->
          <div v-if="session.tracks && session.tracks.length">
            <h6>Track:</h6>
            <p>
              <span
                class="font-weight-normal"
                v-for="(track, trackIndex) in session.tracks"
                :key="`track-${trackIndex}`"
              >
                {{track}}<span v-if="(trackIndex + 1) < session.tracks.length">,&nbsp;</span>
              </span>
            </p>
          </div>

          <!-- presenters -->
          <div
            class="block-info"
            v-if="session?.presenters?.length"
          >
            <h6>Speaker{{ session.presenters > 1 ? "s" : "" }}:</h6>
            <p>
              <template
                v-for="(presenter, presenterIndex) in session.presenters"
              >
                <span v-if="notClickablePresenter">{{presenter.name}}</span>
                <a v-if="!notClickablePresenter" :href="`/${slug}/speakers#speaker-${presenter.id}`">{{presenter.name}}</a>
                <span v-if="(presenterIndex + 1) < session.presenters.length">;&nbsp;</span>
              </template>
            </p>
          </div>

          <!-- description -->
          <div class="block-info" v-if="session.description">
            <h6>Description:</h6>
            <p style="white-space: pre-wrap;" v-html="session.description"></p>
          </div>

          <!-- learning objectives list -->
          <div
            class="block-info"
            v-if="session?.learning_objectives?.length"
          >
            <h6>
              Learning Objective{{
                session.learning_objectives > 1 ? "s" : ""
              }}:
            </h6>
            <ul class="list-items-styles">
              <li
                v-for="(item, index) in session.learning_objectives"
                :key="`learning-objectives-${index}`"
              >
                {{ item }}
              </li>
            </ul>
          </div>

          <!-- learning levels list -->
          <div
            class="block-info"
            v-if="session?.learning_levels?.length"
          >
            <h6>
              Learning Levels{{ session.learning_levels > 1 ? "s" : "" }}:
            </h6>
            <ul class="list-items-styles">
              <li
                v-for="(item, index) in session.learning_levels"
                :key="`learning-levels-${index}`"
              >
                {{ item }}
              </li>
            </ul>
          </div>

          <!-- disclosure -->
          <div class="block-info" v-if="session?.disclosure?.body">
            <h6>Disclosure:</h6>
            <p v-html="session.disclosure.body"></p>
          </div>

          <!-- in-person approved approvals or unapproved approvals or  pending approvals -->
          <div class="block-info" v-if="inPersonApprovals">
            <h6>{{ inPersonApprovalTitle }}</h6>

            <p style="margin-bottom: 0;" v-show="session?.approvals?.inperson?.approved?.length">
              <span class="text-success"><i class="fa-regular fa-check-circle"></i> CE credits:</span>
              <span
                v-for="(item, itemIndex) in session.approvals.inperson.approved"
                :key="`ce-approvals-${itemIndex}`">{{item}}<span v-if="(itemIndex+1)<session.approvals.inperson.approved.length">, </span></span>
            </p>

            <p style="margin-bottom: 0;" v-show="session?.approvals?.inperson?.unapproved?.length">
              <span class="text-danger"><i class="fa-regular fa-remove"></i> CE not approved for:</span>
              <span
                v-for="(item, itemIndex) in session.approvals.inperson.unapproved"
                :key="`ce-unapprovals-${itemIndex}`">{{item}}<span v-if="(itemIndex+1)<session.approvals.inperson.unapproved.length">, </span></span>
            </p>

            <p v-show="session?.approvals?.inperson?.pending?.length">
              <span class="text-warning"><i style="padding-left: 3px;" class="fa-regular fa-shield-exclamation"></i> CE pending approval:</span>
              <span
                v-for="(item, itemIndex) in session.approvals.inperson.pending"
                :key="`ce-pending-${itemIndex}`">{{item}}<span v-if="(itemIndex+1)<session.approvals.inperson.pending.length">, </span></span>
            </p>
          </div>

          <!-- virtual approved approvals or unapproved approvals or  pending approvals -->
          <div class="block-info" v-if="virtualApprovals">
            <h6>{{ virtualApprovalTitle }}</h6>

            <p style="margin-bottom: 0;" v-show="session?.approvals?.virtual?.approved?.length">
              <span class="text-success"><i class="fa-regular fa-check-circle"></i> CE credits:</span>
              <span
                v-for="(item, itemIndex) in session.approvals.virtual.approved"
                :key="`virtual-ce-approvals-${itemIndex}`">{{item}}<span v-if="(itemIndex+1)<session.approvals.virtual.approved.length">, </span></span>
            </p>

            <p style="margin-bottom: 0;" v-show="session?.approvals?.virtual?.unapproved?.length">
              <span class="text-danger"><i class="fa-regular fa-remove"></i> CE not approved for:</span>
              <span
                v-for="(item, itemIndex) in session.approvals.virtual.unapproved"
                :key="`virtual-ce-unapprovals-${itemIndex}`">{{item}}<span v-if="(itemIndex+1)<session.approvals.virtual.unapproved.length">, </span></span>
            </p>

            <p v-show="session?.approvals?.virtual?.pending?.length">
              <span class="text-warning"><i style="padding-left: 3px;" class="fa-regular fa-shield-exclamation"></i> CE pending approval:</span>
              <span
                v-for="(item, itemIndex) in session.approvals.virtual.pending"
                :key="`virtual-ce-pending-${itemIndex}`">{{item}}<span v-if="(itemIndex+1)<session.approvals.virtual.pending.length">, </span></span>
            </p>
          </div>

          <!-- materials -->
          <div
            class="col-md-12"
            v-if="session.materials && session.materials.length"
          >
            <div class="block-info">
              <h6>Session Material{{ session.materials > 1 ? "s" : "" }}:</h6>

              <ul class="list-group tickets">
                <li
                  style="list-style-type: none"
                  v-for="(file, fileIndex) in session.materials"
                  :key="`file-${fileIndex}`"
                >
                  <span class="pull-left" style="margin-top: 3px">
                    <span
                      :data-icon="file.icon_font_code"
                      :class="`icon ${file.icon_font_code} fontcode`"
                      >&nbsp;</span
                    >
                  </span>

                  <div class="pull-left" style="margin: 8px 0 0 10px">
                    <a
                      :href="
                        file.url && file.url.length ? file.url : file.uuid_url
                      "
                      target="_blank"
                      >{{ file.title }}</a
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    session: {
      type: Object,
      default: () => {}
    },
    slug: {
      type: String,
      default: () => ""
    },
    isHybridConference: {
      type: Boolean,
      required: true
    },
    notClickablePresenter: {
      type: Boolean,
      default: false
    },
    conferenceId: {
      type: Number,
      required: false,
    },
  },
  computed: {
    inPersonApprovals() {
      const approved = this.session?.approvals?.inperson?.approved?.length ? +this.session.approvals.inperson.approved.length : 0;
      const unapproved = this.session?.approvals?.inperson?.unapproved?.length ? +this.session.approvals.inperson.unapproved.length : 0;
      const pending = this.session?.approvals?.inperson?.pending?.length ? +this.session.approvals.inperson.pending.length : 0;

      return approved + unapproved + pending;
    },

    virtualApprovals() {
      const approved = this.session?.approvals?.virtual?.approved?.length ? +this.session.approvals.virtual.approved.length : 0;
      const unapproved = this.session?.approvals?.virtual?.unapproved?.length ? +this.session.approvals.virtual.unapproved.length : 0;
      const pending = this.session?.approvals?.virtual?.pending?.length ? +this.session.approvals.virtual.pending.length : 0;

      return approved + unapproved + pending;
    },

    inPersonApprovalTitle() {
      const title =
        this.inPersonApprovals > 1
          ? "In-Person credits:"
          : "In-Person credits:";

      return title;
    },

    virtualApprovalTitle() {
      const title =
        this.virtualApprovals > 1
          ? "Virtual credits:"
          : "Virtual credits:";

      return title;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
